import {
  billableAllocationLabel, billingNumber, billingRateLabel,
  formatBillingMoney, formatBillingQuantity, groupBillableCalculationSteps,
} from './billingCalculation.js';

export function billingCustomerText(value) {
  if (typeof value !== 'string' || /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(value)) return '';
  return value.replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
}

const nonnegative = (value) => billingNumber(value) !== null && billingNumber(value) >= 0 ? billingNumber(value) : null;

/** Both billing presentations use this explicit allowlist, never raw route/source data. */
export function billableServiceContext(item) {
  const context = item?.service_context;
  const locations = (values) => Array.isArray(values) ? values.map((value) => ({
    name: billingCustomerText(value?.name), address: billingCustomerText(value?.address),
  })).filter((value) => value.name || value.address) : [];
  return {
    customer_name: billingCustomerText(context?.customer_name),
    origin: locations(context?.origin), destination: locations(context?.destination),
    origin_kind: ['visit', 'day_start'].includes(context?.origin_kind) ? context.origin_kind : null,
    route_km: nonnegative(context?.route_km), delivered_tons: nonnegative(context?.delivered_tons),
    estimated_onsite_seconds: nonnegative(context?.estimated_onsite_seconds),
  };
}

export function billablePrestationGroups(post, allItems) {
  if (!post) return [];
  const originals = groupBillableCalculationSteps(allItems);
  return groupBillableCalculationSteps(post.items).map((group) => {
    const date = group.date ? new Intl.DateTimeFormat('fr-CA', { dateStyle: 'long' }).format(new Date(`${group.date}T12:00:00`)) : 'Date non disponible';
    const sameDate = originals.filter((member) => member.date === group.date);
    const revision = sameDate.findIndex((member) => member.key === group.key) + 1;
    return { ...group, label: `${date}${sameDate.length > 1 ? ` · Relevé ${revision}` : ''}` };
  });
}

/** Formats the saved inputs displayed in the compact prestation inspector. */
export function billablePrestationDetails(item) {
  const details = item.calculation_details;
  const hourly = item.billing_unit === 'heure';
  const block = hourly ? details?.block : null;
  const source = hourly ? billingNumber(details?.source_seconds) : null;
  const gross = block ? billingNumber(block.gross_seconds) : source;
  const net = block ? billingNumber(block.net_seconds) : source;
  const travel = billingNumber(block?.travel_seconds);
  const onsite = billingNumber(block?.onsite_seconds);
  const excluded = gross !== null && net !== null && gross >= net ? gross - net : null;
  const amount = item.pricing_pending ? null : billingNumber(item.line_total);
  const rate = billingNumber(item.unit_rate);
  const quantityLabel = formatBillingQuantity(item.quantity, item.billing_unit);
  const amountLabel = amount === null ? 'À déterminer' : formatBillingMoney(amount, item.currency_code);
  const rateLabel = rate === null ? '—' : billingRateLabel(rate, item.billing_unit, item.currency_code);
  const allocation = hourly ? billableAllocationLabel(item) : '';
  return { hourly, block, net, travel, onsite, excluded, allocation, amount,
    quantityLabel, amountLabel, rateLabel, exceptional: Boolean(details?.exceptional_rate) };
}
